import Vue from 'vue'
import VueMq from 'vue-mq'

export default async function () {
  let plugin = VueMq;
  if (process.server) {
    plugin = {
      install(Vue, options) {
        Vue.prototype.$mq = options.defaultBreakpoint
      }
    }
  }

  const moduleOptions = {"breakpoints":{"sm":480,"md":1024,"lg":1217,"lgr":1407,"xl":1680,"xxl":Infinity}}
  Vue.use(plugin, moduleOptions)
}
